<div #workspaceSelect class="w-full min-w-0 overflow-hidden">
  <p-toolbar styleClass="workspaceToolbar">
    <ng-template #start>
      <p-tabs [value]="selectedTabIndex" [scrollable]="true" class="min-w-0 flex-1">
        <p-tablist [cdkDropListDisabled]="selectedEditTab" cdkDropList (cdkDropListDropped)="drop($event)" cdkDropListOrientation="horizontal">
          @for(ws of workspaces; track ws.index){
          <p-tab cdkDrag [cdkDragBoundary]="'.p-tablist'" class="cursor-grab active:cursor-grabbing" [value]="ws.index" (click)="selectWorkspace(ws.index)">
            @if (ws?.index !== selectedEditTab?.index) {
              <div class="text-xs p-1" (contextmenu)="!isLoading() && onContextMenu($event, ws)"
                (dblclick)="!isLoading() && editWorkspace(ws, false)">
                {{ ws.name }}
              </div>
            } @else {
              <input #editNameBox (keydown)="handleInput($event)" type="text" pInputText [(ngModel)]="ws.name"
                (blur)="renameWorkspace(ws?.index, ws?.name)"
                (keyup.enter)="renameWorkspace(ws?.index, ws?.name)"
                [ngClass]="{ menuItem: ws?.index === selectedEditTab.index }" [disabled]="isLoading()" />
            }
          </p-tab>
          }
        </p-tablist>
      </p-tabs>
    </ng-template>

    <ng-template #end>
      <div class="ml-1 space-x-1">
        <p-button outlined="true" size="small" icon="pi pi-plus" tooltipPosition="top" pTooltip="Add New Workspace"
          (onClick)="insertWorkspace(workspaces.length + 1)">
        </p-button>
        <p-button outlined="true" size="small" icon="pi pi-clone" tooltipPosition="top" pTooltip="Copy tab and component layout from another design"
          (onClick)="copyWorkspace()">
        </p-button>
      </div>
    </ng-template>
  </p-toolbar>
</div>

<p-contextMenu [target]="workspaceSelect" [model]="workspaceContextMenu" appendTo="body"></p-contextMenu>